import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { JOB_STATUS_LABELS } from '../utils/statusConstants';

const Requests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/requests')
      .then((r) => setRequests(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">My requests</h1>
        <Link
          to="/requests/new"
          className="bg-teal-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-teal-800"
        >
          New request
        </Link>
      </div>
      {loading ? (
        <p className="text-slate-500">Loading…</p>
      ) : (
        <div className="bg-white rounded-xl shadow border border-slate-100 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-slate-600">
              <tr>
                <th className="px-5 py-3">Job #</th>
                <th className="px-5 py-3">Location</th>
                <th className="px-5 py-3">Status</th>
                <th className="px-5 py-3">Scheduled</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((j) => (
                <tr key={j.id} className="border-t border-slate-100">
                  <td className="px-5 py-3">
                    <Link to={`/requests/${j.id}`} className="text-teal-700 font-medium">
                      {j.job_number}
                    </Link>
                  </td>
                  <td className="px-5 py-3">{j.location_label || j.city}</td>
                  <td className="px-5 py-3">{JOB_STATUS_LABELS[j.status] || j.status}</td>
                  <td className="px-5 py-3">
                    {j.scheduled_start ? new Date(j.scheduled_start).toLocaleString() : '—'}
                  </td>
                </tr>
              ))}
              {requests.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-5 py-8 text-center text-slate-500">
                    No requests yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Requests;
